
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import Head from "next/head"

import SEO from "@/meta/SEO"
import { getHelpCenterArticleProps } from "@/organisms/HelpCenterArticle/functions/getHelpCenterArticleProps"
import HelpCenterArticle from "@/organisms/HelpCenterArticle/HelpCenterArticle"
import Help from "@/templates/Help/Help"

function FansiVideoHelp() {
  const sectionsList = [
    ["what_is_fansi_video"],
    ["what_should_be_in_instructions_from_creator"],
    [
      "after_what_time_after_ordering_i_will_get_video",
      "/help/returns-and-complaints",
    ],
    [
      "what_if_creator_didnt_deliver_video_in_time",
      "/help/returns-and-complaints?section=4",
    ],
    [
      "what_if_creator_didnt_do_what_i_asked_him",
      "/help/returns-and-complaints?section=4",
    ],
    ["how_can_i_share_fansi_video"],
  ]

  const props = getHelpCenterArticleProps(
    "helpFansiVideo",
    "fansi_video",
    sectionsList
  )

  return (
    <>
      <Head>
        <title>Centrum pomocy | fansi.pl</title>
        <SEO description="W Centrum Pomocy znajdziesz odpowiedzi na najczęściej zadawane pytania dotyczące platformy fansi, logowania oraz zakupu produktów od influencerów." />
        {/* <meta name="robots" content="noindex,nofollow" /> */}
      </Head>
      <HelpCenterArticle {...props} />
    </>
  )
}
FansiVideoHelp.Layout = Help
export default FansiVideoHelp


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/help/fansi-video',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  